import { RefreshCw, Truck, CalendarClock } from "lucide-react";
import { Container, Button } from "@/components/atoms";
import { useSiteSettings } from "@/hooks/use-site-settings";

// Subscribe & Save (frame 24:31).
export function SubscribeSave() {
  // DRB-38: home-page marketing for a feature that is switched off.
  const { settings } = useSiteSettings();
  if (settings.subscriptionsEnabled !== true) return null;

  const perks = [
    {
      icon: RefreshCw,
      title: "Save 15%",
      body: "Automatic discount on every recurring shipment.",
    },
    {
      icon: Truck,
      title: "Free shipping",
      body: "On all subscription deliveries, always.",
    },
    {
      icon: CalendarClock,
      title: "Total control",
      body: "Skip, pause, or cancel anytime from your account.",
    },
  ];
  return (
    <section className="bg-leaf-green-2/20 py-14">
      <Container className="grid items-center gap-8 md:grid-cols-2">
        <div>
          <span className="font-condensed text-xs font-bold uppercase tracking-widest text-leaf-green-ink">
            Never run out
          </span>
          <h2 className="mt-2 font-condensed text-3xl font-bold text-night-blue">
            Subscribe &amp; Save
          </h2>
          <p className="mt-2 max-w-md text-night-blue/70">
            Consistency is where CBD does its best work. Set a 30, 60, or 90-day
            cadence and save on every order.
          </p>
          <Button to="/shop" className="mt-5">
            Start a Subscription
          </Button>
        </div>
        <div className="grid gap-4">
          {perks.map((p) => (
            <div
              key={p.title}
              className="flex items-start gap-3 rounded-card bg-white p-4"
            >
              <p.icon
                size={22}
                className="mt-0.5 shrink-0 text-leaf-green-ink"
              />
              <div>
                <h3 className="font-condensed font-bold text-night-blue">
                  {p.title}
                </h3>
                <p className="text-sm text-night-blue/70">{p.body}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
